module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-2-Social-Static-Ad-w540.98164052.webp";